var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "refresh-ccw"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "#BED4E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4 7V11H8",
    stroke: "#34629D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20 18V13H15",
    stroke: "#34629D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.1745 9.66605C17.8057 8.55104 17.1788 7.55414 16.3524 6.76839C15.526 5.98264 14.5269 5.43365 13.4485 5.17263C12.3701 4.91161 11.2475 4.94708 10.1853 5.27572C9.12318 5.60437 8.15618 6.21548 7.37455 7.05203L4 10.444M20 13.556L16.6255 16.948C15.8438 17.7845 14.8768 18.3956 13.8147 18.7243C12.7525 19.0529 11.6299 19.0884 10.5515 18.8274C9.47307 18.5664 8.47404 18.0174 7.64761 17.2316C6.82119 16.4459 6.1943 15.449 5.82545 14.3339",
    stroke: "#34629D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestore);
export default __webpack_public_path__ + "static/media/Restore.d5497d7653936f289014407f42d7fc36.svg";
export { ForwardRef as ReactComponent };